import React, { forwardRef } from 'react';
import { ButtonBase, IconArrowDown16, Link } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import scrollIntoViewWithHeader from '../../utils/scrollIntoViewWithHeader';

const SimilarItemsLink = forwardRef((_props, ref) => {
  const [, dispatch] = useProductDetailsPageContext();

  return (
    <Link
      endIcon={<IconArrowDown16 />}
      setting="body-small-fixed"
      underline="inverse"
      onClick={() => {
        scrollIntoViewWithHeader(ref.current);
        dispatch({ type: 'JUMP_LINK_CLICKED' });
      }}
      as={ButtonBase}
      mt={{ sm: 0.5, md: 0.75, lg: 0 }}
      mb={{ sm: 0.5, md: 0 }}
      ml={{ lg: 1 }}
    >
      Shop similar styles
    </Link>
  );
});

export default SimilarItemsLink;
